export const logStackTrace = (limit = 10, formatter) => {
  try {
    Error.stackTraceLimit = limit;
    throw new Error();
  } catch (error) {
    let stack = error?.stack;
    if (formatter) {
      stack = formatter(stack);
    }
    if (stack !== null) {
      console.info(stack);
    }
  }
};
